<template>
  <div class="pos-fnb-final-ticket-wrapper">
    <button class="btn-modal-close" @click="callClose()">&times;</button>
    <div class="h4 font-weight-bold text-center">
      Pick Up Food and Beverages
    </div>
    <div class="position-relative h-100 mt-5">
      <div class="col-10 mx-auto">
        <div class="row">
          <div class="col-6 border-right-dashed pr-5">
            <div class="pos-min-height-wrapper d-flex align-items-center">
              <div
                class="pos-mobile-number"
                :class="!showSendSmsSection ? 'disbled-section' : ''"
              >
                <form>
                  <div class="row">
                    <span>{{
                      phoneError && phoneError.length > 0 ? phoneError : ""
                    }}</span>
                    <div class="col-4 mb-4">
                      <!--variant="dropdown-curve bg-theme-light"-->
                      <!--:text="getCustMobCode"-->
                      <b-dropdown
                        variant="dropdown-curve"
                        class="w-100 text-center mr-3"
                        :disabled="!showSendSmsSection"
                        :text="getCustMobCode ? getCustMobCode : 'Code'"
                      >
                        <div class="px-2 pb-2">
                          <input
                            required
                            autofocus
                            type="search"
                            placeholder="Search Code"
                            v-on:keyup="onSearchCode($event.target.value)"
                            v-on:keydown="onSearchCode($event.target.value)"
                            v-on:search="onSearchCode($event.target.value)"
                            v-model="searchCode"
                            class="form-control form-control-sm"
                          />
                        </div>
                        <b-dropdown-item
                          href="#"
                          v-for="(countrycode, countryIndex) in Countries"
                          :key="countryIndex"
                          v-on:click="
                            onSelectHandler('countrycode', countrycode)
                          "
                          v-if="countrycode.country_mob_code != null"
                          >{{ countrycode.country_mob_code }}</b-dropdown-item
                        >
                      </b-dropdown>
                    </div>
                    <div class="col-8 mb-4 pl-0">
                      <input
                        v-model="input_number"
                        type="number"
                        placeholder="Mobile Number"
                        class="mobile-number"
                        :disabled="!showSendSmsSection"
                        v-on:keydown="
                          (e) => {
                            if (!/[0-9]/.test(e.key) && e.keyCode !== 8) {
                              e.preventDefault();
                            }
                          }
                        "
                      />
                    </div>

                    <div class="col-11 mx-auto">
                      <div class="row">
                        <div
                          class="col-4 mb-2"
                          v-for="(value, index) in phone_value"
                          :key="index"
                        >
                          <button
                            v-if="index == phone_value.length - 1"
                            v-on:click="onSliceNUmber()"
                            class="number"
                            :disabled="!showSendSmsSection"
                          >
                            {{ value.name }}
                          </button>
                          <button
                            v-else-if="value.name != ''"
                            v-on:click="onClickNumber(index)"
                            class="number"
                            :disabled="!showSendSmsSection"
                          >
                            {{ value.name }}
                          </button>
                          <button
                            v-else
                            @click.prevent.stop="clearInput"
                            class="number"
                            :disabled="!showSendSmsSection"
                          >
                            C
                          </button>
                        </div>
                        <!-- <div class="col-4 mb-2" v-for="(loop , mobile) in 12" :key="mobile">
                          <button
                            @click.prevent.stop="onClickNumber(mobile)"
                            v-if="mobile < 11"
                          >{{ mobile }}</button>
                          <button v-else @click.prevent.stop="clearPhoneNumber">C</button>
                        </div>-->
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
            <div class="text-center">
              <!-- will add functionlity for this later just call function which we used for Sendsms on pos (said by sanath on 14th Aug 2020)-->
              <button
                :disabled="!showSendSmsSection"
                v-on:click="onSendSMS()"
                :class="!showSendSmsSection ? 'disbled-section' : ''"
                class="btn-blue-lg bg-blue text-white mr-1"
              >
                Send SMS
              </button>
              <!-- <button
                @click.prevent.stop="phonenumberHandler"
                class="btn-blue-lg bg-blue text-white ml-1"
              >Save</button>-->
            </div>
          </div>

          <div class="col-6 pl-5">
            <div class="pos-min-height-wrapper" style="height:125%;">
              <div class="pos-fnb-summary-box border shadow">
                <!-- BOX OFFICE TICKET -->
                <div
                  v-if="
                    bookingDetails && Object.keys(bookingDetails).length > 0
                  "
                  class="pos-final-ticket-new"
                >
                  <div class="row">
                    <div
                      class="
                        col-3
                        border-right-dashed border-dark
                        align-items-center
                        text-center
                        pos-ticket-cutter
                      "
                    >
                      <h5 class="font-weight-bold mb-3">
                        Ticket No: {{ bookingDetails.sb_booking_code }}
                      </h5>
                      <img
                        src="@/assets/img/icons/movie-rolling.svg"
                        class="img-fluid"
                      />
                    </div>
                    <div class="col-6 pl-5">
                      <h5 class="font-weight-bold">
                        {{ bookingDetails.movie_title }}
                      </h5>
                      <div class="text-blue lh-1 mb-2">
                        <span class="font-weight-bold mr-2">{{
                          bookingDetails.lang_name
                        }}</span>
                        <b-badge variant="primary">{{
                          bookingDetails.mf_name
                        }}</b-badge>
                      </div>
                      <ul class="list-inline" style="font-weight: 500">
                        <li class="list-inline-item">
                          {{ bookingDetails.og_show_date | getDay }}
                        </li>
                        <li class="list-inline-item">|</li>
                        <li class="list-inline-item">
                          {{ bookingDetails.og_show_date | getMonth }}&nbsp;
                          {{ bookingDetails.og_show_date | getDayDigit }}
                        </li>
                        <!-- <li class="list-inline-item">|</li>
                        <li class="list-inline-item">2019</li>-->
                        <li class="list-inline-item">|</li>
                        <li class="list-inline-item">
                          {{ bookingDetails.ss_start_show_time }}
                        </li>
                        <li>{{ bookingDetails.show_date }}</li>
                      </ul>
                      <div>
                        <h6 class="text-blue font-weight-bold mb-1">
                          {{ bookingDetails.screen_name }}
                        </h6>
                        <ul class="list-inline mb-0">
                          <li class="list-inline-item">
                            <img
                              src="@/assets/img/icons/armchair.svg"
                              height="20"
                              width="20"
                              alt
                            />
                            :
                          </li>
                          <li class="list-inline-item">
                            {{ bookingDetails.seats }}
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div class="col-3 align-self-end pr-5 text-right">
                      <h6 class="font-weight-bold mb-0">
                        Total Amount :
                        {{ currFormat(bookingDetails.sb_total_amount) }}
                      </h6>
                    </div>
                  </div>
                </div>

                <header class="summary-header" style="padding-top:10px;">
                  <div class="col-12">
                    <div class="row">
                      <div class="col-4">
                        <span class="text-lightgrey">Item</span>
                      </div>
                      <div class="col-4 px-0 text-center">
                        <span class="text-lightgrey">Qty</span>
                      </div>
                      <div class="col-4 text-right">
                        <span class="text-lightgrey pr-4 mr-2">Price</span>
                      </div>
                    </div>
                  </div>
                </header>

                <div class="summary-content" style="height: calc(100% - 250px)">
                  <!---160--->
                  <div
                    class="col-12"
                    v-for="(item, itemIndex) in Items"
                    :key="itemIndex"
                  >
                    <div class="row align-items-center py-2">
                      <div class="col-4 pr-2">
                        <small class="font-weight-bold">{{
                          item.item_name
                        }}</small>
                        <small
                          v-if="
                            item.hasOwnProperty('final_combo_array') &&
                              item.final_combo_array.length > 0
                          "
                          ><br />{{
                            item.final_combo_array
                              .map((x) => x.quantity + "x- " + x.item_name)
                              .join(", ")
                          }}</small
                        >
                        <small
                          v-if="
                            item.hasOwnProperty('customizations') &&
                              item['customizations'].length > 0
                          "
                        >
                          <div
                            v-for="(singleCustomItem,
                            singleCustomItemIndex) in item['customizations']"
                            :key="singleCustomItemIndex"
                          >
                            <span>{{
                              singleCustomItem.customization_item_name
                            }}</span>
                          </div>
                        </small>
                      </div>
                      <div class="col-4 px-0 text-center">
                        <strong>{{ item.quantity }}</strong>
                      </div>
                      <div class="col-4">
                        <div
                          class="
                            d-flex
                            w-100
                            align-items-center
                            justify-content-end
                          "
                        >
                          <strong
                            >{{ Currency | uppercase }}
                            {{ currFormat(item.fp_total_amount) }}</strong
                          >
                        </div>
                      </div>
                    </div>
                    <hr class="my-0" />
                  </div>
                  <!-- add-ons -->
                  <div
                    class="col-12"
                    v-for="(item, itemIndex) in selectedAddons"
                    :key="item.add_on_item_name + itemIndex"
                  >
                    <div class="row align-items-center py-2">
                      <div class="col-4 pr-2">
                        <small class="font-weight-bold">{{
                          item.add_on_item_name
                        }}</small>
                      </div>
                      <div class="col-4 px-0 text-center">
                        <strong>{{ item.quantity }}</strong>
                      </div>
                      <div class="col-4">
                        <div
                          class="
                            d-flex
                            w-100
                            align-items-center
                            justify-content-end
                          "
                        >
                          <strong
                            >{{ Currency | uppercase }}
                            {{
                              currFormat(item.add_on_item_price * item.quantity)
                            }}</strong
                          >
                        </div>
                      </div>
                    </div>
                    <hr class="my-0" />
                  </div>
                  <!-- add-ons-ends here -->
                </div>

                <footer class="summary-footer mb-2">
                  <div class="col-12 py-2">
                    <div class="row">
                      <div class="col-4">
                        <span class="text-black">Sub Total</span>
                      </div>
                      <div class="col-8 text-right">
                        <strong
                          >{{ Currency | uppercase }} &nbsp;{{
                            currFormat(SubTotal)
                          }}</strong
                        >
                      </div>
                    </div>
                  </div>
                  <hr class="my-0" />
                  <!-- CUSTOMIZATIONS -->
                  <div
                    class="col-12 py-1"
                    v-if="selectedChargeableCustomizations.length > 0"
                  >
                    <div
                      v-if="selectedChargeableCustomizations.length > 0"
                      v-for="(singleItem,
                      singleItemIndex) in selectedChargeableCustomizations"
                      :key="singleItemIndex"
                      class="row"
                    >
                      <div class="col-4">
                        <span class="text-black">{{
                          singleItem.item_name
                        }}</span>
                      </div>
                      <div class="col-8 text-right">
                        <strong
                          >{{ Currency | uppercase }}&nbsp;{{
                            currFormat(singleItem.fp_total_amount)
                          }}</strong
                        >
                      </div>
                    </div>
                  </div>
                  <hr
                    class="my-0"
                    v-if="selectedChargeableCustomizations.length > 0"
                  />
                  <!-- CUSTOMIZATIONS -->
                  <!-- customizationAdditionalTaxes -->
                  <div
                    class="col-12 py-1"
                    v-if="customizationAdditionalTaxes.length > 0 && false"
                  >
                    <div
                      v-if="customizationAdditionalTaxes.length > 0 && false"
                      v-for="(singleCharge,
                      singleChargeIndex) in customizationAdditionalTaxes"
                      :key="singleChargeIndex"
                      class="row"
                    >
                      <div class="col-4">
                        <span class="text-black">{{
                          singleCharge.ct_name
                        }}</span>
                      </div>
                      <div class="col-8 text-right">
                        <strong
                          >{{ Currency | uppercase }}&nbsp;{{
                            currFormat(singleCharge.charge_value)
                          }}</strong
                        >
                      </div>
                    </div>
                  </div>
                  <hr
                    class="my-0"
                    v-if="customizationAdditionalTaxes.length > 0 && false"
                  />
                  <!-- customizationAdditionalTaxes -->
                  <div
                    v-if="Taxes.length > 0"
                    v-for="(Tax, TaxIndex) in Taxes"
                    :key="TaxIndex"
                    class="col-12 py-2"
                  >
                    <div class="row">
                      <div class="col-4">
                        <span class="text-black">{{ Tax.ct_name }}</span>
                      </div>
                      <div class="col-8 text-right">
                        <strong v-if="Tax.pas_is_rebate == 'N'"
                          >{{ Currency | uppercase }}&nbsp;{{
                            currFormat(Tax.totalTax)
                          }}</strong
                        >
                        <strong v-else
                          >{{ Currency | uppercase }}&nbsp;-{{
                            currFormat(Tax.totalTax)
                          }}</strong
                        >
                      </div>
                    </div>
                  </div>
                  <hr class="my-0" v-if="Taxes.length > 0" />
                  <!-- ADDON EXTRA CHARGES -->
                  <div class="col-12 py-2" v-if="selectedAddons.length > 0">
                    <div
                      v-if="addonsAdditionalCharges.length > 0"
                      v-for="(AdditionalTax,
                      AdditionalTaxIndex) in addonsAdditionalCharges"
                      :key="AdditionalTaxIndex + AdditionalTax.ct_name"
                      class="row"
                    >
                      <div class="col-4">
                        <span class="text-black">{{
                          AdditionalTax.ct_name | uppercase
                        }}</span>
                      </div>
                      <div class="col-8 text-right">
                        <strong
                          >{{ Currency | uppercase }}&nbsp;{{
                            currFormat(AdditionalTax.totalTax)
                          }}</strong
                        >
                      </div>
                    </div>
                  </div>
                  <hr class="my-0" v-if="selectedAddons.length > 0" />
                  <!-- ENDS -->
                  <!-- OFFER -->
                  <div
                    v-if="offerApplied && Object.keys(offerApplied).length > 0"
                    class="col-12"
                  >
                    <div class="d-flex flex-wrap border-bottom-lightgrey py-1">
                      <div class="col-5 pl-0">
                        <!-- class="text-lightgrey" -->
                        <strong>Offer Applied</strong>
                      </div>
                      <div class="col-7 px-0">
                        <div class="d-flex justify-content-end">
                          <strong class="d-block text-danger"
                            ><span
                              >-{{ Currency | uppercase }}&nbsp;{{
                                currFormat(offerPrice)
                              }}</span
                            ></strong
                          >
                        </div>
                      </div>
                      <div class="col-12 pt-1 px-0 d-flex">
                        <strong class="fs-10"
                          >({{
                            offerApplied.offer_title ||
                              offerApplied.offer_code ||
                              offerApplied.voucher_title ||
                              offerApplied.voucher_code
                          }})</strong
                        >
                      </div>
                      <div class="col-4 pr-0">
                        <div class="d-flex w-100 justify-content-between"></div>
                      </div>
                    </div>
                  </div>
                  <hr
                    class="my-0"
                    v-if="offerApplied && Object.keys(offerApplied).length > 0"
                  />
                  <div
                    v-if="
                      RemainingCashRefundOfferAmount &&
                        parseInt(RemainingCashRefundOfferAmount) > 0
                    "
                    class="col-12"
                  >
                    <div class="d-flex flex-wrap border-bottom-lightgrey py-1">
                      <div class="col-5 pl-0">
                        <!-- class="text-lightgrey" -->
                        <strong>Cash Refund</strong>
                      </div>
                      <div class="col-7 px-0">
                        <div class="d-flex justify-content-end">
                          <strong class="d-block text-danger"
                            ><span
                              >{{ Currency | uppercase }}&nbsp;{{
                                currFormat(RemainingCashRefundOfferAmount)
                              }}</span
                            ></strong
                          >
                        </div>
                      </div>

                      <div class="col-4 pr-0">
                        <div class="d-flex w-100 justify-content-between"></div>
                      </div>
                    </div>
                  </div>
                  <hr
                    class="my-0"
                    v-if="
                      RemainingCashRefundOfferAmount &&
                        parseInt(RemainingCashRefundOfferAmount) > 0
                    "
                  />
                  <div class="col-12 py-2">
                    <div class="row">
                      <div class="col-4">
                        <span class="text-black"> Total</span>
                      </div>
                      <div class="col-8 text-right">
                        <strong
                          >{{ Currency | uppercase }}&nbsp;{{
                            currFormat(
                              Total +
                                customizationTotalPrice +
                                selectedAddonsTotalPrice -
                                offerPrice
                            )
                          }}</strong
                        >
                      </div>
                    </div>
                  </div>
                  <hr class="my-0" />
                  <div class="col-12 py-2">
                    <div class="row">
                      <div class="col-4">
                        <span class="text-black">Loyalty Amount </span>
                      </div>
                      <div class="col-8 text-right">
                        <strong> {{ currFormat(getStoreLoyality) }}</strong>
                      </div>
                    </div>
                  </div>
                  <hr class="my-0" />
                  <div class="col-12 py-2" v-if="isCashCardTransaction">
                    <div class="row">
                      <div class="col-4">
                        <span class="text-black">Cash Card</span>
                      </div>
                      <div class="col-8 text-right text-danger">
                        <strong>
                          -{{ Currency | uppercase }}
                          {{ currFormat(CashCardAmount) }}</strong
                        >
                      </div>
                    </div>
                  </div>
                  <hr class="my-0" />
                  <!-- Final -->
                  <div class="col-12 py-2">
                    <div class="row">
                      <div class="col-4">
                        <span class="text-black">Final Total </span>
                      </div>
                      <div class="col-8 text-right">
                        <strong
                          >{{ Currency | uppercase }}&nbsp;{{
                            currFormat(
                              Total +
                                customizationTotalPrice +
                                selectedAddonsTotalPrice -
                                offerPrice -
                                getStoreLoyality -
                                CashCardAmount
                            )
                          }}</strong
                        >
                      </div>
                    </div>
                  </div>
                </footer>
              </div>
            </div>
            <div class="text-center my-2">
              <p>Earned Points: {{ getEarnedPointsAfterFnbBooking }}</p>
            </div>
            <div class="text-center mt-2">
              <button
                v-if="isReprint"
                @click="onPrintHandler(true)"
                class="btn-blue-lg"
              >
                Reprint
              </button>
              <button
                v-if="!isReprint"
                @click="onPrintHandler"
                class="btn-blue-lg"
              >
                Print
              </button>
              <button
                v-if="ShowPrintReceipt == 'Y'"
                @click="printreceipt"
                class="btn-blue-lg"
              >
                Print Receipt
              </button>
              <button
                v-if="
                  printTimCardHolderReceipt &&
                    USE_TIM_INTEGRATION == 'Y' &&
                    PRINT_TIM_CARD_RECEIPT_POS == 'Y'
                "
                @click="printCreditCardReceiptTim()"
                class="btn-blue-lg bg-blue text-white ml-1"
              >
                Card Receipt
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <fnb-sales-receipt
      ref="FNb_SalesReceipt"
      :itemsList="itemsList"
      :taxes="taxes"
      :taxesTotal="taxesTotal"
      :currency="currency"
    ></fnb-sales-receipt>

    <ChangeUserLocationPopUp :onCancelUserLocationPopUp="callClose" />

    <div ref="onPrint" class="d-none">
      <div v-html="EjsData"></div>
    </div>
    <div
      id="cardReceiptTim"
      ref="cardReceiptTim"
      style="width: 100%; text-align: center;"
      class="d-none"
    >
      <pre style="white-space: pre-wrap" v-text="TIM_CARDHOLDER_RECEIPT"></pre>
    </div>
    <div id="v-idle" style="display: none">
      <!-- :duration in seconds-->
      <v-idle
        @idle="onIdleCheckout"
        :events="['mousemove', 'keypress', 'ontouchstart', 'onclick']"
        :loop="true"
        :duration="pos_final_page_standBy_time * 60"
      />
    </div>
    <ManagerAuthLogin
      :moduleName="'fnbFinalTicket'"
      :onCheckAuth="onCheckAuthentication"
      :refId="'authManager_fnbFinalTicket'"
    />
  </div>
</template>

<script>
  import FNbSReceipt from "@/components/Pages/PosBookingContainer/ReceiptTemplates/fnb_sales_receipts";
  import { EventBus } from "@/main";
  import PosFnbService from "@/services/PosFnbService";
  import Printd from "printd";
  import { mapState, mapGetters, mapActions } from "vuex";
  import MasterService from "@/services/MasterService.js";
  import { BASEURL } from "@/config/index";
  import ChangeUserLocationPopUp from "@/components/Partials/ChangeUserLocationPopUp";
  import { authenticationService } from "@/services/AuthenticationService";
  import ManagerAuthLogin from "@/components/Partials/AuthManagerLoginPopup";
  import { Role, CLIENT_NAME, CLIENT_NAMES_OBJ } from "@/helper/Role";

  export default {
    components: {
      // "onecopy-template": OCTemplate,
      // "threecopy-template": ThreeCTemplate,
      // "default-template": DefaultTemplate,
      "fnb-sales-receipt": FNbSReceipt,
      ChangeUserLocationPopUp,
      ManagerAuthLogin,
    },
    data() {
      return {
        noAuth: false,
        phoneError: null,
        SelectedCountryCode: "",
        isReprint: false,
        phonenumber: "",
        EjsData: null,
        user_id: null,
        phone_value: [
          { name: "1" },
          { name: "2" },
          { name: "3" },
          { name: "4" },
          { name: "5" },
          { name: "6" },
          { name: "7" },
          { name: "8" },
          { name: "9" },
          { name: "" },
          { name: "0" },
          { name: "<-" },
        ],
        Countries: [],
        CodeListCopy: [],
        searchCode: "",
        CountriesMethod: {
          GET: "/admin/",
          tableName: "ms_countries",
          urlKey: "countries",
        },
      };
    },
    props: {
      printText: {
        type: String,
        default: "Print",
      },
      onClickHandler: {
        type: Function,
      },
      itemsList: {
        type: Array,
        default: () => [],
      },
      currency: {
        type: String,
        default: "",
      },
      subTotal: {
        type: Number,
        default: null,
      },
      total: {
        type: Number,
        default: null,
      },
      taxes: {
        type: Array,
        default: () => {
          return [];
        },
      },
      taxesTotal: {
        type: Number,
        default: null,
      },
      onNumberSubmit: {
        type: Function,
      },
      onPrintCall: {
        type: Function,
      },
      getloyaltyAmountNew: {
        type: Number,
        default: null,
      },
    },

    computed: {
      DirectPrint() {
        return this.$store.getters.DirectPrint;
      },
      printTimCardHolderReceipt() {
        return this.$store.getters.TIM_CARDHOLDER_RECEIPT;
      },
      ShowPrintReceipt() {
        return this.$store.getters.showPrintReceiptBtn;
      },
      RemainingCashRefundOfferAmount() {
        return this.$store.getters.RemainingCashRefundOffer;
      },
      pos_final_page_standBy_time() {
        console.log(
          "parseInt(this.$store.getters.POS_FINAL_PAGE_STANDBY_TIME)",
          parseInt(this.$store.getters.POS_FINAL_PAGE_STANDBY_TIME)
        );
        return parseInt(this.$store.getters.POS_FINAL_PAGE_STANDBY_TIME);
      },
      isCashCardTransaction() {
        return this.$store.getters.isCashCardTransaction;
      },
      CashCardAmount() {
        return this.$store.getters.isCashCardDetail.hasOwnProperty("cardAmount")
          ? this.$store.getters.isCashCardDetail.cardAmount
          : 0;
      },
      showSendSmsSection() {
        if (
          this.$store.getters.ShowSendSMSSection &&
          this.$store.getters.ShowSendSMSSection == "N"
        ) {
          return false;
        } else {
          return true;
        }
      },
      input_number: {
        get() {
          return this.$store.getters.customer_mobile_number;
        },
        set(value) {
          this.$store.dispatch("updateCustomerMobileNumber", value);
        },
      },
      getCustMobCode() {
        return this.$store.getters.getCustMobCode;
      },
      GET_MERIT_GIFT_CARD_DETAILS() {
        return this.$store.getters.GET_MERIT_GIFT_CARD_DETAILS;
      },
      MeritCardAmount() {
        let amount = 0;
        let gc_details = this.$store.getters.GET_MERIT_GIFT_CARD_DETAILS;
        if (gc_details) {
          amount = +parseFloat(gc_details["amount"]).toFixed(2);
        }
        return amount;
      },
      _getStoreLoyality() {
        let merit_amount = 0;
        let gc_details = this.$store.getters.GET_MERIT_GIFT_CARD_DETAILS;
        if (gc_details) {
          merit_amount = +parseFloat(gc_details["amount"]).toFixed(2);
        }
        if (merit_amount > 0) {
          return merit_amount;
        } else {
          return this.$store.getters.getFnbloyaltyAmount;
        }
      },
      getStoreLoyality() {
      return this.$store.getters.getFnbloyaltyAmount;
    },
      selectedChargeableCustomizations() {
        return this.$store.getters.selectedChargeableCustomizations;
      },
      customizationTotalPrice() {
        return this.$store.getters.customizationTotalPrice;
      },
      customizationAdditionalTaxes() {
        return this.$store.getters.customizationAdditionalTaxes;
      },
      offerPrice() {
        return this.$store.getters.getOfferPrice;
      },
      offerApplied() {
        return this.$store.getters.getSelectedOffer;
      },
      bookingDetails() {
        return this.$store.getters.BOOKING_DETAILS;
      },

      Items() {
        return this.itemsList;
      },
      Currency() {
        return this.currency;
      },
      SubTotal() {
        return this.subTotal ? this.subTotal : null;
      },
      Total() {
        return this.subTotal !== null && this.taxesTotal !== null
          ? this.subTotal + this.taxesTotal
          : null;
      },
      Taxes() {
        return this.taxes;
      },
      TaxesTotal() {
        return this.taxesTotal ? this.taxesTotal : null;
      },
      getOrderId() {
        return this.$store.getters.getOrderId;
      },
      ...mapGetters([
        "selectedAddons",
        "selectedAddonsTotalPrice",
        "addonsAdditionalCharges",
        "getEarnedPointsAfterFnbBooking",
        "MANAGER_AUTH_FOR_REPRINT",
        "TIM_CARDHOLDER_RECEIPT",
        "USE_TIM_INTEGRATION",
        "PRINT_TIM_CARD_RECEIPT_POS",
      ]),
    },
    mounted() {
      this.user_id = this.secureStore.get("USINFO").user_id;
      this.getCountriesList();
      this.SelectedCountryCode = this.getCustMobCode;

      if (this.getOrderId && this.user_id && this.DirectPrint == "Y") {
        this.onPrintHandler();
      }
    },
    methods: {
      printCreditCardReceiptTim() {
        if (this.TIM_CARDHOLDER_RECEIPT) {
          // this.$store.dispatch("onSetAndSendLog", {
          //   action: `Selected TIM Cardholder option`,
          //   page_name: "POS booking",
          //   api_name: window.location.hash,
          // });
          const { cinema_id } = this.secureStore.get("USINFO");
          var userAgent = navigator.userAgent.toLowerCase();
          if (userAgent.indexOf(" electron/") > -1) {
            try {
              if (this.$socket) {
                this.$socket.emit("on_print_ticket", {
                  ttype: "tim_card_holder_receipt",
                  htmlData: document.getElementById("cardReceiptTim").outerHTML,
                });
              }
            } catch (err) {}
          } else {
            let loader = this.$loading.show();
            this.EjsData = this.TIM_CARDHOLDER_RECEIPT;
            this.$nextTick(() => {
              loader.hide();
              const p = new Printd();
              if (this.$refs.cardReceiptTim) {
                p.print(this.$refs.cardReceiptTim, []);
              }
            });
          }
        } else {
          this.$toasted.show("Card holder receipt not found");
        }
      },
      onIdleCheckout() {
        console.log("Idle checkout call close");
        this.callClose();
      },
      onSearchCode() {
        if (this.searchCode && this.searchCode.length > 0) {
          this.Countries = this.CodeListCopy.filter((x) => {
            if (
              x.country_mob_code &&
              x.country_mob_code
                .toLowerCase()
                .includes(this.searchCode.toLowerCase())
            ) {
              return x;
            }
          });
        } else {
          this.Countries = this.CodeListCopy;
        }
      },
      getCountriesList: function() {
        this.Countries = [];
        let body = this.getRequestBody("GET", undefined, this.CountriesMethod);
        MasterService.GlobalRequest(body)
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              this.Countries = data.Records;
              this.CodeListCopy = data.Records;
            } else {
              console.log("show error :", data.message);
            }
          })
          .catch((error) => {
            console.log("show error :", error);
          });
      },
      _onSliceNUmber: function() {
        if (this.phonenumber.length > 0) {
          this.phonenumber = this.phonenumber.slice(0, -1);
        }
        if (this.phonenumber.length == 0) {
          this.phonenumber = "";
        }
      },
      printreceipt: function() {
        EventBus.$emit("printFnbSalesReceipt");
      },
      checkDifferentUserLocation() {
        let default_token = authenticationService.get("DFLT_USINFO");
        let logged_token = authenticationService.get("USINFO");

        if (
          default_token &&
          logged_token &&
          default_token.hasOwnProperty("user_id") &&
          logged_token.hasOwnProperty("user_id")
        ) {
          if (default_token.user_id == logged_token.user_id) {
            return true;
          } else {
            this.$bvModal.show("userLocationPopup");
            return false;
          }
        } else {
          return true;
        }
      },
      callClose: function(check = true) {
        let checkCount = 0;

        if (check) {
          if (!this.checkDifferentUserLocation()) {
            checkCount++;
          } else {
            checkCount = 0;
          }
        }

        if (checkCount == 0) {
          try {
            if (this.$socket) {
              this.$socket.emit("home_page");
            }
          } catch (err) {}
          this.$store.dispatch("ResetCustomizationData");
          this.$store.dispatch("clearAllInput");
          this.$store.dispatch("ResetCardTrxDetails");
          this.$store.dispatch("onResetEmployeeDetails");
          this.$store.dispatch("resetFnbReservation");
          this.$store.dispatch("resetCashCardData");
          this.onClickHandler({ name: "showFnBOrderDetails" });
        }
      },
      clearPhoneNumber: function() {
        this.phonenumber = null;
        this.input_number = 0;
      },
      clearInput: function() {
        this.phonenumber = "";
        this.input_number = "";
      },
      onSliceNUmber: function() {
        this.$store.dispatch("sliceNumber");
      },
      _onClickNumber: function(index) {
        this.phonenumber += this.phone_value[index].name;
      },
      onClickNumber: function(index) {
        this.input_number += this.phone_value[index].name;
      },
      inputChange(event) {},
      onSendSMS() {
        console.log("this.input_number", this.input_number);
        console.log("this.SelectedCountryCode", this.getCustMobCode);
        if (this.input_number.length > 0 && this.getCustMobCode.length > 0) {
          this.$store.dispatch("sendSms", { source: "fnb" });
        } else {
          this.$toasted.show(
            "Please enter mobile number and select country code"
          );
        }
      },
      phonenumberHandler: function(event, input) {
        let phoneReg = /\d{7,12}/;
        if (!this.phonenumber) {
          this.$toasted.show("Please enter mobile number");
          // this.phoneError = "Please Enter Phone Number.";
        } else if (this.phonenumber && !phoneReg.test(this.phonenumber)) {
          this.phoneError =
            "Phone number must be digits and minimum 7 digits allows.";
        } else {
          // this.$store.dispatch("onSetAndSendLog", {
          //   action: `SMS option selected for ticket at number : ${this.phonenumber}`,
          //   page_name: "FNB booking",
          //   api_name: window.location.hash,
          // });
          this.$store.dispatch("sendSms");

          // this.onNumberSubmit({ phonenumber: this.phonenumber });
        }
        this.phoneError && this.phoneError.length > 0
          ? setTimeout(() => {
              this.phoneError = null;
            }, 1500)
          : "";
      },
      onCheckAuthentication(response) {
        const { valid, name } = response;
        if (valid) {
          if (name == "fnbFinalTicket") {
            this.noAuth = true;
            this.$bvModal.hide("authManager_fnbFinalTicket");
            this.onPrintHandler();
          }
        }
      },
      onPrintHandler: function(isReprint = false) {
        if (isReprint && !this.noAuth && this.MANAGER_AUTH_FOR_REPRINT == "Y") {
          this.$bvModal.show("authManager_fnbFinalTicket");
        } else {
          // this.$store.dispatch("onSetAndSendLog", {
          //   action: `Selected Print option .`,
          //   page_name: "FNB booking",
          //   api_name: window.location.hash,
          // });
          // this.onPrintCall({ path: "printCall" });
          let payload = {
            OrderCode: this.getOrderId,
            Type: "Print",
            UserID: this.user_id,
            isReprint: this.isReprint,
            cinemaId: this.secureStore.get("USINFO").cinema_id,
          };
          console.log(
            "checkClient",
            CLIENT_NAMES_OBJ
            // this.authorizeClient(this.CLIENT_NAMES_OBJ.empire_iraq)
          );
          let checkClient = this.authorizeClient(
            CLIENT_NAMES_OBJ.empire_iraq_lebanon
          );
          console.log("checkedClient", checkClient);
          var userAgent = navigator.userAgent.toLowerCase();
          if (userAgent.indexOf(" electron/") > -1) {
            try {
              if (this.$socket) {
                // console.log('data',this.$store.getters)
                //console.log("showBookingId", this.bookingDetails.sb_id)
                // let checkClient = this.authorizeClient(
                //   CLIENT_NAMES_OBJ.empire_iraq
                // );
                console.log(
                  "checkClient from here",
                  this.authorizeClient(CLIENT_NAMES_OBJ.empire_iraq_lebanon)
                );
                if (checkClient) {
                  this.$socket.emit("on_print_ticket", {
                    baseurl: BASEURL,
                    ttype: "fnb",
                    ...payload,
                  });

                  setTimeout(() => {
                    this.$socket.emit("on_print_ticket", {
                      baseurl: BASEURL,
                      ttype: "fnb-security",
                      ...payload,
                    });
                  }, 2000);
                } else {
                  this.$socket.emit("on_print_ticket", {
                    baseurl: BASEURL,
                    ttype: "fnb",
                    ...payload,
                  });
                }
              }
            } catch (err) {}
          } else {
            if (CLIENT_NAME.EMPIRE == this.CLIENT_SETUP_NAME) {
              PosFnbService.GetFnbOrderEjs(payload)
                .then(async (response) => {
                  const { data } = response;

                  this.EjsData = data;

                  this.$nextTick(() => {
                    const p = new Printd();
                    if (this.$refs.onPrint && this.EjsData != null) {
                      p.print(this.$refs.onPrint, []);
                    }
                  });

                  // console.log("response :>> ", response);
                })
                // .then(() => {
                //   PosFnbService.GetFnbOrderSecurityEjs(payload).then(response => {
                //     const data = { response };
                //     this.EjsData = data;

                //     this.$nextTick(() => {
                //       loader.hide();
                //       const p = new Printd();
                //       if (this.$refs.onPrint && this.EjsData != null) {
                //         p.print(this.$refs.onPrint, []);
                //       }
                //     });
                //   });
                // })
                .catch(this._CatchError);
            } else {
              let loader = this.$loading.show();
              PosFnbService.GetFnbOrderEjs(payload)
                .then(async (response) => {
                  const { data } = response;

                  this.EjsData = data;

                  this.$nextTick(() => {
                    loader.hide();
                    const p = new Printd();
                    if (this.$refs.onPrint && this.EjsData != null) {
                      p.print(this.$refs.onPrint, []);
                    }
                  });

                  // console.log("response :>> ", response);
                })
                .catch(this._CatchError);
            }
          }
          this.isReprint = true;
        }
        // .finally(() => {
        //   setTimeout(() => loader.hide(), 1000);
        // });
      },
      onSelectHandler: function(type, value) {
        this.SelectedCountryCode = value.country_mob_code;
        this.$store.dispatch("updateCountryMobCode", value.country_mob_code);
      },
    },
  };
</script>

<style>
  .pos-fnb-final-ticket-wrapper {
    left: 0;
    bottom: 0;
    width: 100%;
    z-index: 999;
    position: fixed;
    /* height: calc(100vh - 75px); */
    height: 100vh;
    background-color: #fff;
  }

  .pos-fnb-final-ticket-wrapper .btn-modal-close {
    top: 0px;
    right: 0px;
    position: absolute;
  }

  .fnb-movie-ticket {
    border-radius: 5px;
    box-shadow: 1px 1px 3px 1px #808080ad;
  }

  .fnb-movie-table {
    width: 100%;
  }

  .fnb-mt-cut::before,
  .fnb-mt-cut::after {
    content: "";
    width: 25px;
    right: -13px;
    z-index: 22;
    height: 25px;
    display: block;
    border-radius: 50%;
    position: absolute;
    background-color: #fff;
  }

  .fnb-mt-cut::before {
    top: -13px;
    border-bottom: 2px solid grey;
  }

  .fnb-mt-cut::after {
    bottom: -13px;
    border-top: 2px solid grey;
  }

  .fnb-movie-table td:nth-child(2) {
    width: 60px;
    text-align: right;
  }
  .disbled-section {
    cursor: not-allowed;
    opacity: 0.4;
  }
</style>



// WEBPACK FOOTER //
// src/components/Pages/PosFnbContainer/posFnBFinalTicket.vue